// Worker
// eslint-disable-next-line import/default
import QuickSearchWorker from './quickSearch.worker';

// Constants
import { INIT, SEARCH, SEARCH_RESULT } from './quickSearchConstants';

const quickSearchWorker = new QuickSearchWorker();

export const reindexBoardSummariesForSearch = (boardSummaries) => {
    quickSearchWorker.postMessage({
        type: INIT,
        args: {
            boardSummaries,
        },
    });
};

const quickSearch = ({ query, viewedBoardIds, currentBoardId }) =>
    new Promise((resolve) => {
        quickSearchWorker.postMessage({
            type: SEARCH,
            args: {
                query,
                viewedBoardIds,
                currentBoardId,
            },
        });

        quickSearchWorker.onmessage = (event) => {
            const { type, args } = event.data;

            if (type === SEARCH_RESULT) {
                const { result } = args;

                resolve(result);
            }
        };
    });

export default quickSearch;
